function triggerShare() {
    const shareData = {
        title: document.title, // Page title
        text: "View this product in AR.", // Optional description
        url: window.location.href, // Full URL of the current page
    };

    // Check if the Web Share API is supported
    if (navigator.share) {
        navigator.share(shareData)
        .then(() => console.log('Page shared successfully!'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
        alert('Sorry, but an unexpected error occured. Copy the link instead: ' + shareData.url);
    }
}

function triggerCopyUrl(event) {
    const button = event.currentTarget;

    navigator.clipboard.writeText(window.location.href).then(() => {
        button.textContent = 'Copied!';
        setTimeout(() => (button.textContent = 'Copy Link'), 1500);
    });
}